export function getCookiesMap() {
  const cookies = document.cookie
    .split(";")
    .reduce((cookieObj, cookieString) => {
      const [name, value] = cookieString.split("=").map((c) => c.trim());
      if (name) {
        cookieObj[name] = decodeURIComponent(value);
      }
      return cookieObj;
    }, {});
  return cookies;
}

function hasAuthorization(host) {
  if (host === "localhost") return true;
  const cookies = getCookiesMap();
  delete cookies["_dd_s"]; // Remove datadog RUM cookie
  if (Object.keys(cookies).length > 0) {
    return true;
  }
  return false;
}

export const auth = hasAuthorization(window.location.hostname);
